export const colorShade = (color, amount) => {
	const newColor = color
		.replace(/^#/, '')
		.replace(/../g,
			(col) => (`0${Math.min(255, Math.max(0, Number.parseInt(col, 16) + amount))
				.toString(16)}`).slice(-2));

	return `#${newColor}`;
};
